export enum AvailabilityScheduleType {
  Availability = "Availability",
  Leave = "Leave"
}

